import { motion } from "framer-motion";
import { ShieldCheck, Sparkles, Droplets, CarFront, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToSection } from "@/lib/scroll";

const SERVICES = [
  {
    icon: ShieldCheck,
    testid: "service-antirouille",
    title: "Traitement antirouille spécialisé",
    desc: "Protection annuelle du châssis et de la carrosserie contre le sel, le calcium et la corrosion des hivers québécois. Produit pénétrant de grade professionnel.",
    tag: "Protection",
  },
  {
    icon: Sparkles,
    testid: "service-ceramique",
    title: "Polissage & coating céramique",
    desc: "Correction de peinture en plusieurs étapes suivie d'une protection céramique hydrophobe. Lustre miroir et défense UV pour des années.",
    tag: "Signature",
  },
  {
    icon: Droplets,
    testid: "service-cire",
    title: "Cire de protection haute performance",
    desc: "Cires et sealants haut de gamme qui nourrissent la peinture, rehaussent la profondeur du fini et facilitent les lavages subséquents.",
    tag: "Finition",
  },
  {
    icon: CarFront,
    testid: "service-nettoyage",
    title: "Nettoyage complet intérieur & extérieur",
    desc: "Detailing intégral : habitacle, cuir, moquettes, jantes, compartiment moteur et vitres. Chaque recoin inspecté à la main.",
    tag: "Intégral",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-28 lg:py-36 relative">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Eyebrow>Nos prestations</Eyebrow>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-4xl max-w-xl">
            Des services <span className="gold-gradient-text">d'exception</span>
          </h2>
          <p className="text-sm text-white/50 max-w-sm font-light leading-relaxed">
            Quatre expertises, un même standard : un véhicule remis dans un état supérieur à celui du concessionnaire.
          </p>
        </div>
      </Reveal>

      <div className="grid sm:grid-cols-2 gap-6 lg:gap-8">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.1}>
            <motion.article
              data-testid={s.testid}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className="group glass-panel rounded-2xl p-8 lg:p-10 h-full relative overflow-hidden hover:border-gold/40 transition-[border-color,box-shadow] duration-500 hover:shadow-[0_20px_60px_rgba(212,175,55,0.12)]"
            >
              <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-gold/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <div className="flex items-start justify-between mb-8">
                <span className="flex h-14 w-14 items-center justify-center rounded-xl border border-gold/30 bg-gold/10 text-gold transition-transform duration-500 group-hover:rotate-6 group-hover:scale-110">
                  <s.icon size={24} strokeWidth={1.6} />
                </span>
                <span className="text-[10px] uppercase tracking-[0.3em] text-gold/70 border border-gold/25 rounded-full px-3 py-1">
                  {s.tag}
                </span>
              </div>
              <h3 className="font-display font-bold text-xl mb-4 leading-snug">{s.title}</h3>
              <p className="text-sm text-white/60 font-light leading-relaxed mb-8">{s.desc}</p>
              <button
                data-testid={`${s.testid}-cta`}
                onClick={() => scrollToSection("#contact")}
                className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold/80 group-hover:text-gold transition-colors duration-300"
              >
                Demander ce service
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </button>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
